// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"b6d712a9","141":"1649ba81","641":"0493a0ef","666":"c1c4c8d7","729":"f9d9a802"}[chunkId] + ".css";
};